import { useParams, useLoaderData } from 'react-router-dom';
import CaseLibraryPage from './library/CaseLibraryPage';
import CaseWorkspaceLayout from './workspace/CaseWorkspaceLayout';

/**
 * Case Builder root: library when no :name, workspace when editing a case.
 */
export default function CaseBuilderEnhanced() {
    const { name } = useParams();
    const loaderData = useLoaderData();

    if (!name) {
        return <CaseLibraryPage />;
    }

    return (
        <CaseWorkspaceLayout
            data={loaderData.data}
            name={name}
            loaderError={loaderData.error}
            blockSchema={loaderData.blockSchema}
            regionSchema={loaderData.regionSchema}
            stainSchema={loaderData.stainSchema}
            schemas={loaderData.schemas}
            metadataOptions={loaderData.metadataOptions}
        />
    );
}
